module.exports = __webpack_public_path__ + "img/base_bg3.79690b84.jpg";